import { FetchResponseType, SectionGroup } from "@utilities/types"
import { collection, db, doc, getDoc, getDocs } from "./config";
import { collectionsEnum } from "./constants";

export const getDocumentations = async(): Promise<FetchResponseType> => {
    try {
        
        const instructionID = process.env.REACT_APP_INSTRUCTION_ID!;

        const docRef = doc(db, collectionsEnum.instructions, instructionID);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
            return {
                code: 404,
                data: {
                    message: 'Instruction not found',
                }
            }
        }
        const instructions = docSnap.data().instructions;

        const requestSnapshot = await getDocs(collection(db, collectionsEnum.documentations));
        if(requestSnapshot.empty){
            return {
                code: 200,
                data: []
            }
        }

        let docs:SectionGroup[] = [];

        for (const document of requestSnapshot.docs) {
            const docData = document.data() as SectionGroup;
            docs.push(docData);
        }

        return {
            code: 200,
            data: { instructions, docs }
        };

    } catch (error) {
        console.error({error})
        return {
            code: 500,
            data: {
                message: 'Impossible de recuperer la documentation',
            }
        }
    }
}
